import React from 'react';

export default function () {
  return (
    <div>
      <i className="fa fa-circle-o-notch fa-spin fa-3x" />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/app/views/Components/Loading.js